__turbopack_context__.v({
  "Link": "markdown-block-module__xbQi0q__Link",
});
